import { TThunkAction } from '../../types/redux';
import { TUser } from '../../types/user';
import { setUserData } from '../../actions/user';
import {
  TGetUserDataByRequestResponse,
  fetchGetUserDataByRequest,
} from '../../repositories/monolith-python/get-user-data-by-request';
import { ResponseError } from '../../errors/ResponseError';
import { prepareUser } from '../../mappers/user';

export interface IGetUserParameters {
  timeout?: number;
}

export function getUser(parameters?: IGetUserParameters): TThunkAction<Promise<TUser | undefined>> {
  return async (dispatch, getState, context) => {
    const { httpApi, logger } = context;

    try {
      const { response, statusCode }: TGetUserDataByRequestResponse = await fetchGetUserDataByRequest({
        httpApi,
        parameters: {},
        config: {
          ecnhancersConfig: {
            timeout: parameters && parameters.timeout,
          },
        },
      });

      if (statusCode !== 200) {
        throw new ResponseError({
          domain: 'user#getUser',
          message: response.message,
          details: {
            error: response.errors,
          },
        });
      }

      const {
        data: { user: userRaw },
      } = response;

      const user: TUser = prepareUser({ user: userRaw });

      dispatch(setUserData(user));

      return user;
    } catch (error) {
      logger.error(error);

      return undefined;
    }
  };
}
